import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateNodeIris =
  (prevIri: string, newIri: string) =>
  (model: Model): Record<string, string> => {
    const updatedKeys: Record<string, string> = {};

    model.nodeDataArray.forEach((node) => {
      if (isModelConceptClass(node) && node.value === prevIri) {
        const newNodeKey = getModelConceptClassKey(newIri);
        updatedKeys[node.key] = newNodeKey;

        // update the node key + value
        setDataProperty<ModelConceptClass>(model)(node, 'value', newIri);
        model.setKeyForNodeData(node, newNodeKey);
      }
    });

    return updatedKeys;
  };
